/**
 * Badge/Pill Component per UX Spec page 3
 * - Tool-colour-50 bg
 * - Tool-colour-800 text
 * - 8px h-padding
 * - 3px radius
 * - Used for: status labels, content type, source system indicators
 */

interface BadgeProps {
  variant?: 'primary' | 'secondary' | 'accent' | 'critical' | 'warning' | 'success';
  children: React.ReactNode;
  className?: string;
}

const variantStyles = {
  primary: 'bg-t1-light text-t1-dark',
  secondary: 'bg-t2-light text-t2-primary',
  accent: 'bg-t3-light text-t3-primary',
  critical: 'bg-red-50 text-critical-red',
  warning: 'bg-yellow-50 text-warning-amber',
  success: 'bg-green-50 text-success-green',
};

export function Badge({ variant = 'primary', children, className = '' }: BadgeProps) {
  const styles = variantStyles[variant];

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-chip text-caption font-medium ${styles} ${className}`}>
      {children}
    </span>
  );
}
